import { OnInit, Component, ViewEncapsulation } from '@angular/core';
import { BsModalRef } from 'ngx-bootstrap';
import { ValidatorService } from 'app/shared/services/validator.service';
import { IResult } from 'app/shared/models/result.model';
import { Subject, Observable } from 'rxjs';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { AppConfig } from 'app/app.config';
import { IDtoCatalog } from 'app/shared/models/dto-catalog.model';
import { DemandService } from 'app/views/appviews/demand.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { DatePipe } from '@angular/common';
import { DocumentService } from 'app/shared/services/document.service';
import { IDtoPreliminaryAudienceEvidenceDetail } from 'app/shared/models/legal/demand/dto-preliminary-audience-evidence-detail.model';

@Component({
    selector: 'app-modal-restart-demand',
    templateUrl: './modal-restart-demand.template.html',
    styleUrls: ['./modal-restart-demand.style.scss'],
    encapsulation: ViewEncapsulation.None
})

export class ModalRestartDemandComponet implements OnInit {
    /**Validadores */
    private validator = ValidatorService;
    private fsaFlags = [false];
    private errorMessages: any;
    /**Formularios */
    private form: FormGroup;
    /**Variable de trasporte de datos */
    private result: IResult;
    /**Retorno a pantalla padre */
    public onClose: Subject<boolean>;

    private liquidationId: number;
    private stage: string;
    private catalogProceduralStages: IDtoCatalog[];
    constructor(private bsModalRef: BsModalRef
        , private formBuilder: FormBuilder
        , private configGeneral: AppConfig
        , private demandService: DemandService
        , private spinner: NgxSpinnerService
        , private datePipe: DatePipe
        , private documentService: DocumentService) {
        this.initializeFormEvidence();
    }
    ngOnInit(): void {
        this.onClose = new Subject();
        switch (this.stage) {
            case 'Cita conciliatoria':
            case 'Recepción de la demanda':
                this.catalogProceduralStages = [{ id: 1, name: 'Cita conciliatoria' }] as IDtoCatalog[];
                break;
            case 'Contestación de la demanda':
            case 'Ofrecimiento y admisión de pruebas':
            case 'Audiencia de desahogo de pruebas':
            case 'Alegatos':
            case 'Laudos':
                this.catalogProceduralStages = [{ id: 1, name: 'Cita conciliatoria' }, { id: 1, name: 'Recepción de la demanda' }] as IDtoCatalog[];
                break;
            case 'Audiencia Preeliminar':
            case 'Audiencia de Juicio':
                this.catalogProceduralStages = [{ id: 1, name: 'Audiencia Preeliminar' }] as IDtoCatalog[];
                break;
            default:
                break;
        }
        // if (this.stage == 'Cita conciliatoria' || this.stage == 'Recepción de la demanda') {
        //     this.catalogProceduralStages = [{ id: 1, name: 'Cita conciliatoria' }] as IDtoCatalog[];
        // }

    }
    private initializeFormEvidence() {
        this.form = this.formBuilder.group({
            stage: [null, [Validators.required]],
        });
    }
    private submit(): void {
        if (this.form.valid) {
            this.restartProceduralStages();
        } else {
            this.configGeneral.newToast('Validación', 'Capture toda la información requerida para poder continuar', 'error');
        }
    }
    private restartProceduralStages(): void {
        this.spinner.show()
        this.demandService.restartProceduralStages(this.liquidationId, this.form.value.stage)
            .subscribe(
                (x) => {
                    if (x.isCorrect) {
                        this.configGeneral.newToast('Éxito', x.message, 'success');
                        this.onClose.next(true);
                        this.bsModalRef.hide();
                    } else {
                        this.configGeneral.newToast('Error', x.message, 'error');
                    }
                    this.spinner.hide();
                },
                (errMessage) => {
                    this.spinner.hide();
                    this.configGeneral.newToast('Error', errMessage.error.exception, 'error');
                });
    }
    private onCancel(): void {
        this.bsModalRef.hide();
    }
}
